<b>
    <nav style="--bs-breadcrumb-divider: '/';" aria-label="breadcrumb">
        <ol class="breadcrumb ol-sizing">

            @for(property of properties;track property.current)
            {
            <li *ngIf="!property.current" class="breadcrumb-item"><a [routerLink]="property.path">{{property.level}}</a></li>
            <li *ngIf="property.current" class="breadcrumb-item active" aria-current="page">{{property.level}}</li>
            }

        </ol>
    </nav>
</b>